class PredictiveSearch extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this._currentState = 'closed'
  }

  setupListeners () {
    super.setupListeners()

    this.onTrigger = this.onTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleEscapePress = this.handleEscapePress.bind(this)

    this.listeners.add(document, 'click', this.handleClose)
    this.listeners.add(document, 'click', this.onTrigger)
    this.listeners.add(document, 'keyup', this.handleEscapePress)

    this.listeners.add(
      this.externalEls.input.element,
      'input',
      window.BAO.Utils.debounce((e) => {
        this.onChange(e)
      }, 500).bind(this),
    )
  }

  onTrigger (event) {
    const triggerEl = event.target.closest(
      '[data-predictive-search-external-el="input"],[data-predictive-search-external-el="mobile-search"]',
    )
    if (!triggerEl) return

    this.currentState = 'open'

    if (window.BAO.MediaBreakpoints.isSm) return

    this.externalEls.input.element.focus()
  }

  handleClose (event) {
    const triggerEl = event.target.closest(
      '[data-predictive-search-el="close"]',
    )
    if (!triggerEl) return

    this.currentState = 'closed'
  }

  handleEscapePress (event) {
    if (event.code?.toUpperCase() !== 'ESCAPE') return
    if (this.currentState === 'closed') return

    this.currentState = 'closed'
    this.externalEls.input.element.focus()
  }

  onChange () {
    const searchTerm = this.externalEls.input.element.value.trim()

    if (!searchTerm.length) {
      this.setSearchState('default')
      return
    }

    this.currentState = 'open'
    this.setSearchState('results')

    this.getSearchResults(searchTerm)
    // this.getProductSearch(searchTerm)
  }

  getSearchResults (searchTerm) {
    fetch(
      `${window.Shopify.routes.root}search/suggest?q=${searchTerm}&resources[type]=query,page,product,collection,article&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=body,product_type,tag,title,variants.title,vendor&section_id=predictive-search-results`,
    )
      .then((response) => {
        if (!response.ok) {
          const error = new Error(response.status)
          throw error
        }

        return response.text()
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector(
            '#shopify-section-predictive-search-results',
          ).innerHTML
        this.els.results.element.innerHTML = resultsMarkup
      })
      .catch((error) => {
        this.setSearchState('default')
        throw error
      })
  }

  setSearchState (state) {
    this.els.default.element.setAttribute('aria-hidden', state !== 'default')
    this.els.results.element.setAttribute('aria-hidden', state === 'default')
  }

  set currentState (newState) {
    this.inert = newState === 'closed'

    this.classList.toggle('src-Drawer-active', newState === 'open')
    this.classList.toggle('util-SiteOverflowed', newState === 'open')

    document.body.classList.toggle(`lyt-Theme-search`, newState === 'open')

    this._currentState = newState
  }

  get currentState () {
    return this._currentState
  }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch)
}
